export enum FilterType {
    BRANDS= 'brands',
    TYPES= 'types',
    SOURCES= 'sources',
    STATUS= 'status'
}
